var map = {
	"./1193022.png": 48302,
	"./action_shap.png": 75875,
	"./author_img.png": 59027,
	"./banner_bg.png": 5592,
	"./banner_img.png": 30364,
	"./ca_analysis.png": 84161,
	"./chilling_injury_analysis.png": 76307,
	"./ct_analysis.png": 14598,
	"./data_gap_analysis.png": 1170,
	"./divider.png": 71139,
	"./dot.png": 60937,
	"./excursion_analysis.png": 30359,
	"./freezing_injury_analysis.png": 44677,
	"./hemdahl-app.png": 28890,
	"./humidity_analysis.png": 88084,
	"./icon01.png": 91812,
	"./icon01_alt.png": 2284,
	"./icon02.png": 5375,
	"./icon02_alt.png": 28739,
	"./icon3.png": 43442,
	"./icon_04.png": 40898,
	"./icon_05.png": 4555,
	"./icon_shape1.png": 37714,
	"./icon_shape2.png": 68681,
	"./icon_shape3.png": 90560,
	"./icon_shape4.png": 25535,
	"./pathogen_analysis.png": 99763,
	"./power_gap_analysis.png": 43177,
	"./process_1.png": 5071,
	"./process_2.png": 82612,
	"./process_3.png": 3741,
	"./process_4.png": 10946,
	"./process_5.png": 74603,
	"./setpoint_analysis.png": 89935,
	"./shape.png": 10431,
	"./shelf_life_analysis.png": 11574,
	"./shock_analysis.png": 13801,
	"./team1.jpg": 46196,
	"./team2.jpg": 75907,
	"./work1.png": 71924,
	"./work2.png": 46415,
	"./work3.png": 23750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79048;